module.exports = __webpack_public_path__ + "img/swiper_01.4c66ccce.jpg";